(function($){
    "use strict";
    
    $.LocationProvider =  function() { 
        this._component_name = 'location_provider';
        
        this._localization = [];
        
        // listeners
        this._on_localization_loaded = this._on_localization_loaded.bind(this); 
       
        
        $.Component.call(this, $.LocationProvider); 
    };

    $.Component.create($.LocationProvider, {
        _on_localization_loaded: function() {
            var i;
            for (i = 0; i < this._localization.length; i++) {
                if (!this._localization[i].is_ready){
                    return;
                }               
            } 

            this._emit("ready"); 
        }, 
        
        /**
         * Add localization to 1 or more viewers
         * @param {Object} options 
         * @param {OpenSeadragon.Viewer|Array} viewer 
         */
        _add_localization: function(options, viewer) {
            var localization = new $.Localization(options);
            if (Array.isArray(viewer)) {
                var i;
                for (i = 0; i < viewer.length; i++) {
                    viewer[i].abdo.localization = localization;
                }
            }
            else {
                viewer.abdo.localization = localization;
            }
 
            localization.on("ready", this._on_localization_loaded);

            this._localization.push(localization);
        },

        _init_: function(options) {
            // get tracker and osd from category
            this._tracker = this.parent;
            this._osd = this._tracker.parent;
            
            // get array or object if only 1 is present
            if (Array.isArray(options)) {
                this._options = options;
            }
            else if (options) {
                this._options = [options];
            } 
            
            var i;
            // adding 1 Localization for all maps
            if (this._options.length == 1 && this._options.length < this._osd.viewers.length ) {
                this._add_localization(this._options[0], this._osd.viewers); 
            }
            // else adding different localization for all maps in order
            else if (this._options.length == this._osd.viewers.length) {
                for (i = 0; i < this._options.length; i++) {
                    this._add_localization(this._options[i], this._osd.viewers[i]);
                }
            }
            else {
                console.error("can't assign " + this._options.length + " GPS mapping to " + this._osd.viewers.length + " maps");
            }  

            // call init() separately to avoid "ready" event inconsistencies
            for (i = 0; i < this._localization.length; i++) { 
                this._localization[i].init();
            }
            
        }
    }, $.Tracker);
})(ABDOMap);

